/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-ts 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, RequestConfig, RequestFunctionRestArgs, FileData, prepare } from '@bigo/yapi-to-ts'
// @ts-ignore
import request from './request'
// @ts-ignore
import makeRequestHook from './makeRequestHook'

// makeRequest
function makeRequest<TReqeustData, TResponseData>(requestConfig) {
  const req = function (requestData?: TReqeustData, ...args: RequestFunctionRestArgs<typeof request>) {
    return request<TResponseData>(prepare(requestConfig, requestData))
  }
  req.requestConfig = requestConfig
  return req
}

const mockUrl_3_0_0_0 = 'http://yapi.ppx520.com/mock/6645' as any
const dataKey_3_0_0_0 = 'data' as any

export interface BigoDbQryGetUserInfoFromServer6645Request {
  _yy_from: string
  /**
   * 填写时请进行类型范围校验，不要传超出范围的值
   */
  seq_id: number
  my_uid: number
  app_id: number
  /**
   * size不能超过500
   */
  uids: number[]
  /**
   * wiki中拿对应key名字去搜索即可
   */
  other_attr: string[]
}

export interface BigoDbQryGetUserInfoFromServer6645Response {
  _yy_from: string
  my_uid: number
  app_id: number
  seq_id: number
  user_info: {
    '1600026181': {
      _yy_from: string
      version: number
      other_attr_val: {
        data1: string
        user_cover: string
        nick_name: string
      }
    }
  }
  res_code: number
}
type BigoDbQryGetUserInfoFromServer6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/bigo_db_qry/GetUserInfoFromServer',
    'data',
    string,
    string,
    false
  >
>

const bigoDbQryGetUserInfoFromServer6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/bigo_db_qry/GetUserInfoFromServer',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'bigoDbQryGetUserInfoFromServer6645',
}

export const bigoDbQryGetUserInfoFromServer6645 = makeRequest<
  BigoDbQryGetUserInfoFromServer6645Request,
  BigoDbQryGetUserInfoFromServer6645Response
>(bigoDbQryGetUserInfoFromServer6645RequestConfig)
export const useBigoDbQryGetUserInfoFromServer6645 = makeRequestHook<
  BigoDbQryGetUserInfoFromServer6645Request,
  BigoDbQryGetUserInfoFromServer6645RequestConfig,
  ReturnType<typeof bigoDbQryGetUserInfoFromServer6645>
>(bigoDbQryGetUserInfoFromServer6645)
